<template>
	<main id="main" class="main-site">
		<div class="container" style="margin-top: 30px; margin-bottom: 30px">
			<div class="row">
				<div class="col-sm-2 col-xs-6">
					<h3 v-if="loading"> Autenticando </h3> 
				</div>
				<div class="col-sm-2 col-xs-6">
					<Loader v-if="loading" style="margin-top: 10px;"/>
				</div>
				<div class="col-sm-12 col-xs-12">
					<h4> {{ resultMessage }} </h4>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Loader from './partials/Loader.vue';

export default {
  name: 'rdstation-callback',
  data(){
	return {
		resultMessage: '',
		loading: true
	}
  },
  mounted: function(){
	let newCode = this.$route.query.code;
	if (newCode)
		this.validadeCode(newCode);	
	else{
		this.resultMessage = 'Parâmetro "code" inválido';
		this.loading = false;
	}
  },
  methods: {
	validadeCode: function(newCode) {
		
		var xhr = new XMLHttpRequest();
		xhr.onload = () => {
		let response = JSON.parse(xhr.responseText);
		if (response)
			this.resultMessage = response;
			this.loading = false;
		}

		xhr.open("POST", this.$apiUrl + "RDStation.svc/callback");
		xhr.setRequestHeader("Content-Type", "application/json");
		xhr.withCredentials = true;
		xhr.send(JSON.stringify({ code: newCode }));
	}
  }
}
</script>